import {Injectable} from '@angular/core';
import {UiControl} from '../models/uiControl';
import {UIArtefakt} from '../models/uiArtefakt';

// Diese Attribute werden nicht ans Backend zurückgesendet, da Fachentwickler-Content enthalten sein kann
// (z.B. html Tags o.ä.), der vom Gateway abgelehnt wird, weil er als Injection-Angriff gewertet wird.
const ATTRIBUTE_BLACKLIST = [
  'Text',
  'InfoTextTooltipCollapsable',
  'InfoTextPermanent',
  'FehlertextPflichtfeld'
];

@Injectable()
export class SanitizationService {

  constructor() { }

  public sanitize(body: UiControl): UiControl {
    const copy = JSON.parse(JSON.stringify(body)) as UiControl;
    this._removeBlacklistAttributes(copy?.uiVorgang?.UIArtefakt);
    return copy;
  }

  private _removeBlacklistAttributes(artefakte: UIArtefakt[]): void {
    if (!artefakte) {
      return;
    }
    artefakte.forEach(artefakt => {
      ATTRIBUTE_BLACKLIST.forEach(attribute => {
        artefakt[attribute] = null;
      });
      this._removeBlacklistAttributes(artefakt.UIArtefakt);
    });
  }
}
